import * as React from 'react';
import dynamic from 'next/dynamic';

import Checkers from '../../../helpers/class/Checkers';
import Addons from '../../Addons';
import BuilderHead from '../../head/BuilderHead';
import { InlineStyles } from '../index/partials/InlineStyles';

import Sections from './Sections';
import {useEffect} from "react";

const Scripts = dynamic( () => import( '../../Scripts' ), { ssr: false });

export default function Articles ( props ) {

  const domain = props.domain;
  const app_data = props.app_data;
  const app = props.app;
  const builder = props.builder;
  const head = props.head;
  const footer = props.footer;

  const locations = props.locations;
  const navigation = props.navigation;
  const content = props.content;
  const articlesCategories = props.articlesCategories;
  const rgbDesignColor = props.rgbDesignColor;
  const rgbSearchbarColor = props.rgbSearchbarColor;

  const isDesktop = props.isDesktop;

  let title = '';
  let titleFbMeta = '';
  let descFbMeta = '';
  let twitter_img_alt = '';
  let imageFbMeta = '';
  let keywords = head.data.meta_keywords;

  const contactIcons = {
    phoneIcon: app.showPhoneIconOnMenu,
    chatIcon: app.showChatIconOnMenu,
    mailIcon: app.showMailIconOnMenu,
    phoneIconData: app.menuPhoneIconData,
    chatIconData: app.menuChatIconData,
    mailIconData: app.menuMailIconData
  }
  const urlHref = props.urlHref;

  title = content.title;
  title += Checkers.isValidString( content.subtitle ) ? ' - ' + content.subtitle : '';
  title += ' | ' + head.data.title;

  titleFbMeta = content.title;
  descFbMeta = Checkers.objChildExists( content, 'description' ) ? content.description : Checkers.isValidString( content.subtitle ) ? content.subtitle : '';

  twitter_img_alt = content.title;
  twitter_img_alt += Checkers.isValidString( content.subtitle ) ? ' - ' + content.subtitle : '';
  imageFbMeta = Checkers.isValidArray( head.og_image ) ? head.og_image[0].image : null;

  if ( Checkers.objChildExists( content, 'meta_title' ) && Checkers.isValidString( content.meta_title ) ) {
    titleFbMeta = content.meta_title;
    twitter_img_alt = titleFbMeta;
  }
  if ( Checkers.objChildExists( content, 'meta_desc' ) && Checkers.isValidString( content.meta_desc ) ) {
    descFbMeta = content.meta_desc;
  }
  if ( Checkers.objChildExists( content, 'meta_keywords' ) && Checkers.isValidString( content.meta_keywords ) ) {
    keywords = content.meta_keywords;
  }

  if ( props.isArticle ) {
    descFbMeta = content.description.replace( /(<([^>]+)>)/gi, "" );
    imageFbMeta = Checkers.isValidArray( content.images ) && Checkers.isValidString( content.images[0].image ) ? content.images[0].image : null;
  }

  return (
    <>
      <InlineStyles app={app} rgbDesignColor={rgbDesignColor} rgbSearchbarColor={rgbSearchbarColor}/>
      <BuilderHead
        title={title}
        keywords={(props.type =='blog' && Checkers.isValidString(props.app.blogMetaKeywords)) ? props.app.blogMetaKeywords : keywords}
        titleOfficial={head.data.titleOfficial}
        domain={urlHref}
        icon_60={head.data.icon_60}
        icon_76={head.data.icon_76}
        icon_120={head.data.icon_120}
        icon_152={head.data.icon_152}
        icon_256={head.data.icon_256}
        icon={head.data.icon}
        title_fb_meta={(props.type =='blog' && Checkers.isValidString(props.app.blogMetaTitle)) ? props.app.blogMetaTitle : titleFbMeta}
        desc_fb_meta={(props.type =='blog' && Checkers.isValidString(props.app.blogMetaDescription)) ? props.app.blogMetaDescription : keywords}
        image_fb_meta={imageFbMeta}
        site_name_fb_meta={head.data.title}
        lat_fb_meta={head.location.latitude}
        lon_fb_meta={head.location.longitude}
        twitter_img_alt={twitter_img_alt}
        googleSchemaContext={domain}
        googleSchemaTitle={head.data.title}
        googleSchemaStreetAddress={head.location.address}
        googleSchemaCity={head.location.city}
        googleSchemaCountry={head.location.country}
        googleSchemaZip={head.location.zip}
        googleSchemaPhone={head.location.phone}
        designColor={app.designColor}
        font={app.font}
        manager={false}
      />
      <Sections
        type={props.type}
        isBlogArticle={props.isBlogArticle}
        isDesktop={isDesktop}
        app_data={app_data}
        app={app}
        head={head}
        navigation={navigation}
        locations={locations}
        contactIcons={contactIcons}
        content={content}
        articlesCategories={articlesCategories}
        footer={footer}
        builder={builder}
        htmlSections={props.htmlSections}
      />
      {/*<Scripts/>*/}
      <Addons/>
    </>
  )
}
